var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutContent',[_c('AcknowledgementCard',{attrs:{"title":_vm.$t('message.yourConversionWasSuccessful'),"body":_vm.$t('message.pleaseCheckYourOlyWallet')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }